import { render, staticRenderFns } from "./maibo.vue?vue&type=template&id=91c8de86&scoped=true&"
import script from "./maibo.vue?vue&type=script&lang=ts&"
export * from "./maibo.vue?vue&type=script&lang=ts&"
import style0 from "./maibo.vue?vue&type=style&index=0&id=91c8de86&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91c8de86",
  null
  
)

export default component.exports